<template>
  <div class="card card-default">
    <div class="card-header">
      <div class="dropdown float-left">
        <a
          class="dropdown-toggle"
          href="#"
          data-toggle="dropdown"
        >{{ views[currentView] }}</a>
        <div class="dropdown-menu">
          <a
            class="dropdown-item"
            :class="{ active: currentView === view }"
            href="#"
            @click.prevent="changeView(view)"
            v-for="(name, view) in views"
            :key="view"
          >{{ name }}</a>
        </div>
      </div>
      <i
        class="fa fa-circle-o-notch fa-spin float-right"
        v-if="loading"
      />
    </div>
    <div
      class="card-body card-table"
      v-show="!loading"
    >
      <div v-fullcalendar="fullcalendar" />
    </div>
  </div>
</template>

<script>
import Widget from '../../mixins/widget';

export default {
  props: ['user_id'],

  mixins: [Widget],

  data () {
    const me = this;

    return {
      name: 'calendar',
      loading: true,
      error: false,
      data: {},
      currentView: 'basicWeek',
      views: {
        basicWeek: 'Calendário da semana',
        // agendaWeek: 'Agenda',
        listWeek: 'Tarefas da semana',
      },
      fullcalendar: {
        header: false,
        locale: 'pt-br',
        defaultView: 'basicWeek',
        eventLimit: true,
        height: 225,
        views: {
          agenda: {
            eventLimit: 10,
          },
        },
        firstDay: 1,
        eventClick (event) {
          const activity = me.data.filter((current) => current.id == event.id).pop();

          const { deals } = activity.lead;

          if (deals && deals.length) {
            window.open(`/deal#/${deals[deals.length - 1].hashid}`);
          } else {
            window.open(`/lead/${activity.lead.hashid}`);
          }
        },
      },
    };
  },

  watch: {
    loading () {
      Vue.nextTick(() => {
        this.refetchEvents();
      });
    },
  },

  methods: {
    refetchEvents () {
      this.fullcalendar = {
        refreshEvents: true,
        events: this.getEvents(),
      };
    },

    getEvents () {
      return _.map(this.data, (item) => ({
        id: item.id,
        title: item.lead.name || item.lead.email,
        start: item.scheduled_at,
        color: this.getEventColor(item),
      }));
    },

    changeView (view) {
      this.currentView = view;

      this.fullcalendar = {
        changeView: view,
      };
    },

    getEventColor (item) {
      if (item.completed_at) {
        return '#3ed37d';
      }

      const now = new Date();
      const scheduled = new Date(item.scheduled_at);

      if (scheduled.getTime() < now.getTime()) {
        return 'rgba(233,88,88,0.7)';
      }

      return 'rgba(52,152,219,0.7)';
    },
  },
};
</script>
